<template>
  <div class>
    <br>

    <el-form labelPosition="left">
      <el-form-item label="Период">
        <el-date-picker
          format="dd-MM-yyyy"
          v-model="startDate"
          @change="reloadHistory"
          type="date"
          placeholder="Начальная дата"
        ></el-date-picker>-
        <el-date-picker
          format="dd-MM-yyyy"
          v-model="endDate"
          @change="reloadHistory"
          type="date"
          placeholder="Конечная дата"
        ></el-date-picker>
      </el-form-item>
    </el-form>

    <div v-loading="state.loading">
      <el-pagination
        :current-page.sync="state.currentPage"
        @current-change="onPageChange"
        background
        :total="state.totalItems"
        layout="prev, pager, next, total"
        :pageSize="state.pageSize"
      ></el-pagination>
      <br>
      <el-table :data="transactions" size="small" stripe>
        <el-table-column type="expand">
          <template slot-scope="{row, $index}">
            <span class="trans_to" v-if="row.fromStorage">{{row.fromStorage.name}}</span>
            <span>-></span>
            <span class="trans_to" v-if="row.toStorage">{{row.toStorage.name}}</span>
            <div class="trans_body">
              <div v-for="transaction in row.transactions">
                <div>{{transaction.branch}}</div>
                <div>{{transaction.count}}</div>
              </div>
            </div>
            <div class="button">
              <br>
              <el-button size="small" type="primary" @click="print($index)">Распечатать</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Номер заявки" width="200">
          <template slot-scope="{row}">Заявка № {{row.id}}</template>
        </el-table-column>
        <el-table-column label="Дата заявки" width="200">
          <template slot-scope="{row}">{{row.dateCreate | moment("DD-MM-YYYY HH:mm")}}</template>
        </el-table-column>

        <el-table-column label="Пользователь">
          <template slot-scope="{row}">{{row.user? row.user.username : '' }}</template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination
        :current-page.sync="state.currentPage"
        @current-change="onPageChange"
        :total="state.totalItems"
        layout="prev, pager, next"
        background
        :pageSize="state.pageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getHistory, getCategories, getGoods } from "../../../api";
import { findIndex } from "lodash";

export default {
  name: "storage_and_goods_history",
  data() {
    return {
      state: {
        loading: true,
        currentPage: 1,
        pageSize: 20
      },
      startDate: null,
      endDate: null,
      transactions: [],
      categories: [],
      goods: []
    };
  },
  created() {
    this.$forceUpdate();
    this.loadTransactions();
  },
  methods: {
    onPageChange() {
      this.reloadHistory();
    },
    async reloadHistory() {
      this.state.loading = true;
      await this.loadHistory();
      this.buildTransactionItem();
      this.state.loading = false;
    },
    async loadHistory() {
      let params = {
        "dateCreate[before]": this.endDate,
        "dateCreate[after]": this.startDate,
        page: this.state.currentPage,
        limit: this.state.pageSize
      };
      let response = await getHistory(params);
      this.transactions = response.data.items;
      this.state.totalItems = response.data.totalItems;
    },
    loadTransactions() {
      Promise.all([this.loadHistory(), getCategories(), getGoods()]).then(
        response => {
          this.categories = response[1].data.items;
          this.goods = response[2].data.items;
          this.buildTransactionItem();
          this.state.loading = false;
        }
      );
    },
    buildTransactionItem() {
      this.transactions.forEach(transaction => {
        transaction.transactions.forEach(tItem => {
          let index = findIndex(this.goods, fItem => {
            return fItem.id == tItem.product.id;
          });
          if (index < 0) {
            return;
          }
          let categoryId = this.goods[index].category.id;
          let categoryIndex = findIndex(this.categories, fItem => {
            return fItem.id == categoryId;
          });
          let path = "";
          let branch = this.getCategoryTree(
            this.categories[categoryIndex],
            path
          );
          branch += this.goods[index].name;
          tItem.branch = branch;
        });
      });
      this.$forceUpdate();
    },
    getCategoryTree(category, branch) {
      if (!category.parent) {
        branch = category.name + " / " + branch;
        return branch;
      } else {
        branch = category.name + " / " + branch;
        return this.getCategoryTree(category.parent, branch);
      }
    },
    print(index) {
      let html = document
        .querySelectorAll(".el-table__row")
        [index].nextSibling.querySelector("td")
        .cloneNode(true).innerHTML;
      let tableRow = this.transactions[index];

      let doc = document.createElement("div");
      doc.innerHTML =
        `<div>Заявка № ${tableRow.id} - ${this.$moment(
          tableRow.date_create
        ).format("YYYY-MM-DD HH:mm")}</div>` + html;
      doc.querySelector(".button").remove();

      let newWindow = window.open("", "PRINT", "height=400,width=600");
      newWindow.document.write(
        `<html>
            <head><title>${document.title}</title></head>
              <body>
               ${doc.innerHTML}
              </body>
            </html>
        `
      );
      newWindow.document.close(); // necessary for IE >= 10
      newWindow.focus(); // necessary for IE >= 10*/
      newWindow.print();
      newWindow.close();
    }
  }
};
</script>

<style lang="scss">
/*.trans_wrap {*/
/*padding: 10px 0;*/
/*}*/

.trans_item {
  /*border-bottom: 1px solid lightgrey;*/
  border-top: 1px solid lightgrey;
  width: 100%;
  padding: 5px 0;
  margin: 5px 0;

  &:last-child {
    border-bottom: 1px solid lightgrey;
  }
}

i.expand_icon {
  transform: rotate(180deg);
  cursor: pointer;
}

.from_to i {
  transform: rotate(0deg);
}

.trans_body {
  padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/productsStorage/components/storageAndGoods/tabs/history.vue